import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import * as types from '../../constants/prayerFeatureActionTypes';
import { logUI } from "../../api/andyliticsApi";
import { Badge, CircleButton, Icon, Modal, Typography } from "../ecosystem/";
import { DashboardTile } from '../dashboard/DashboardTile';
import * as Tools from "../../helpers/Tools";


export function PrayerFeatureTile({ memberId, getNotificationBadge, showBadge, history, isMobile }) {
    const [showInfo, setShowInfo] = useState(false);
    const infoHeader = 'What is Community Support?';
    const infoMessage =
        'Community Support is both a social & spiritual place that allows you to ask for prayers, share support and comfort others. Baylor Scott & White Health Chaplains are also active here and can respond to your posts.';

    useEffect(() => {
        if (memberId) {
            getNotificationBadge();
        }
    }, [memberId]);

    const onClickCommunitySupport = (tileName) => {
        logUI(`MBHWeb.UI.PrayerFeatureTile.${tileName}.Clicked`, new Date(), Tools.getURLPath());
    };

    return (<>
        <DashboardTile
            className="prayerfeature-tile"
            circleButtonHover
            heading={<div className="col-12 pf-header">
                <Icon name="spiritual-support" set="brand" size="medium" />
                <div className="pf-heading">
                    <Typography
                        type="heading-02"
                        tag="div"
                        bold
                        color={"$color-primary-a2"}>
                        Community Support
                    </Typography>
                    {showBadge ? <Badge show="true"></Badge> : <CircleButton icon="arrow" colorStyle="float" as={'div'} />}
                </div>
            </div>}
            to={"/communitySupport"}
            onClick={() => { onClickCommunitySupport("PrayerFeature") }}
        >
            <div className="col-12 pf-main">
                <Typography
                    type="body-02"
                    tag="div"
                    color={"$color-primary-a2"}>
                    Ask for prayers, share support and comfort others.
                </Typography>
            </div>
        </DashboardTile>
        <Modal
            isOpen={showInfo}
            modalHeader={infoHeader}
            modalBody={infoMessage}
            toggle={() => setShowInfo(!showInfo)}
            onCloseClick={() => setShowInfo(false)}
        />
    </>);

}

const mapStateToProps = state => {
    return {
        memberId: state.prayerFeature.memberId || (state.memberships.featureAmity && state.memberships.featureAmity.memberId),
        showBadge: state.prayerFeature.showBadge
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getNotificationBadge: () => dispatch({ type: types.GET_NOTIFICATION_BADGE })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrayerFeatureTile));